import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@app/router/hocs';
import { trainerRoutes } from './trainer-routes';
import { adminRoutes } from './admin-routes';

export const privateRoutes: RouteObject[] = [
  {
    element: <ProtectedRoute />,
    path: '/',
    children: [
      {
        path: 'dashboard',
        lazy: async () => ({
          Component: (await import('@pages/dashboard')).DashboardPage,
        }),
      },
      {
        path: 'account-settings',
        lazy: async () => ({
          Component: (await import('@pages/account-settings'))
            .AccountSettingsPage,
        }),
      },
      {
        path: 'membership-management/:selectedPlan',
        lazy: async () => ({
          Component: (await import('@pages/membership-management'))
            .MembershipManagement,
        }),
      },
      {
        path: 'event-calendar',
        lazy: async () => ({
          Component: (await import('@pages/event-calendar/'))
            .MemberEventCalendarPage,
        }),
      },
      {
        path: 'event-management',
        lazy: async () => ({
          Component: (await import('@features/role-base-nav'))
            .StaffNavInterceptor,
        }),
      },
      {
        path: 'account-reactivation',
        lazy: async () => ({
          Component: (await import('@pages/account-reactivation'))
            .AccountReactivationPage,
        }),
      },
      ...trainerRoutes,
      ...adminRoutes,
    ],
  },
];
